import { SmartPhrase } from './types';

export const SMART_PHRASES: SmartPhrase[] = [
  {
    description: 'Daily menu plan',
    intervention:
      'Created and reviewed daily menu; RD, or client with supervision from RD, wrote out menu for meals and snacks.',
  },
  {
    description: 'Food group goals',
    intervention:
      'Created and reviewed daily menu plan based on balanced food groups of proteins, fats and carbs at each meal and snack.',
  },
  {
    description: 'Food journaling',
    intervention:
      'Client will keep daily food journals in Healthie electronic food journal; upload pictures, note hunger/fullness, and document feelings/triggers associated with eating.',
  },
  {
    description: 'Hydration',
    intervention:
      'Educated client on importance of hydration and hydration needs. Client will drink;',
  },
  {
    description: 'Meal schedule plan',
    intervention:
      'Created and reviewed meal schedule with client of a schedule of meal and snack time ranges; client will choose from available meal and snack list to eat within appropriate time ranges.',
  },
  {
    description: 'Meal/snack size & volume',
    intervention:
      "Reviewed client's individualized recommendation of portions and volume of food at meals and snacks, and how to advance as tolerate to meet energy needs.",
  },
  {
    description: 'Mindful/intuitive eating',
    intervention:
      'Educated and reviewed with client the principles of mindful and intuitive eating.',
  },
  {
    description: 'Supplemental beverage nutrition',
    intervention:
      'Discussed with client the value and need of supplemental nutritional beverages second to when client is struggling to complete meals and/or consume solid foods.',
  },
  {
    description: 'Mindful eating practices',
    intervention: `• Sit down and unplug.
    • Eat slowly.
    • Chew well.
    • Sip, don't gulp.
    • Embrace senses.
    • Eat when hungry.
    • Adopt an attitude of gratitude.`,
    height: 70,
  },
  {
    description: 'Improve Variety',
    intervention:
      'Educated client on importance of incorporating most food groups and variety of foods that is sufficient to meet micronutrient needs.',
  },
  {
    description: 'Meal/Snack duration',
    intervention:
      'Created and reviewed plan to limit amount of time eating to prevent prolonged meals; 10-15minutes per snack and 20-40minutes per meal.',
  },
  {
    description: 'Plate method',
    intervention:
      'Educated client on the plate method of meal portioning, consisting of 1/2 plate nonstarchy vegetables, 1/4 plate carbs, and 1/4 plate protein.',
  },
  {
    description: 'Volume toleration',
    intervention: `Educated client on strategies if experiencing difficulty tolerating volume at meals:
    • Limit beverages to 8oz at meal
    • Limit carbonated beverages 
    • Reviewed meals that are lower in fiber/volume`,
  },
  {
    description: 'Weight gain/restoration',
    intervention:
      'Reviewed with client individualized nutritional for appropriate weekly weight gain to goal weight range of ###.',
  },
  {
    description: 'HAES',
    intervention:
      'Reviewed with client the principles HAES approach to nutrition and, mindful and intuitive eating.',
  },
  {
    description: 'Dietary Supp Recommendations',
    intervention:
      'Discussed benefit of vitamin, mineral and/or other supplements to meet micronutrient needs to avoid and/or correct deficiencies.',
  },
  {
    description: 'Weight gain/restoration',
    intervention:
      'Reviewed with client individualized meal plan for appropriate weight gain.',
  },
  {
    description: 'Cholesterol',
    intervention:
      'Educated client on importance of a balanced diet with whole grains, fruits and vegetables, and lean protein sources. Discussed limiting saturated fats, trans fats, and cholesterol intake, and choosing unsaturated fats.',
  },
  {
    description: 'Heart Failure',
    intervention:
      'Educated client on limiting sodium and fluid in the diet and maintaining a healthy body weight.',
  },
  {
    description: 'Carb Counting',
    intervention:
      'Educated client on sources of carbs, foods without carbs, portion sizes of foods with 15 grams of carbs, and number of carb servings recommended per meal.',
  },
  {
    description: 'Hypo- and Hyperglycemia',
    intervention:
      'Discussed the symptoms of hyperglycemia and hypoglycemia as well as appropriate treatments when these occur.',
  },
  {
    description: 'Celiac Disease',
    intervention:
      'Educated client on physiology of celiac disease, importance of avoiding gluten, and discussed appropriate food choices.',
  },
  {
    description: 'CKD',
    intervention:
      'Educated client on protein, sodium, potassium, and phosphorus content in the diet with CKD with/without dialysis.',
  },
  {
    description: 'IBS',
    intervention:
      'Performed IBS checklist/questionnaire with client. Discussed FODMAP and foods that trigger symptoms; patient will avoid XXX',
  },
  {
    description: 'Family Nutrition',
    intervention:
      'Created plan with client to improve family nutrition including undistracted meal times, planning meals ahead of time, encouraging particpation from all family members including children, and serving a variety of all food groups.',
  },
  {
    description: 'MyPlate',
    intervention:
      'Educated client on a well-rounded diet and balanced meals using MyPlate to include fruits, vegetables, grains, protein, and dairy.',
  },
  {
    description: 'GERD',
    intervention:
      'Discussed lifestyle tips to alleviate symptoms fo GERD with client including exercise 3-4x per week, wearing loose-fitted clothes, not smoking, raising head of bed, waiting 3 hours after eating to lay down, and consuming small frequent meals. Reviewed foods that are not recommended such as peppermint, chocolate, alcohol, caffeine, coffee/tea, pepper, high-fat foods, and any foods that cause symptoms for the cilent.',
  },
  {
    description: 'Heart Health/CVD',
    intervention:
      'Educated client on eating a balanced diet consisting of whole grains, fruits, vegetables, lean protein, and unsaturated fats. Discussed limiting intake of saturated fats, trans fats, cholesterol, sodium, refined carbs, and alcohol.',
  },
  {
    description: 'Label Reading',
    intervention:
      'Educated client on reading a nutrition facts label; specifically the serving size, calroies, nutrient amounts, and % daily values.',
  },
  {
    description: 'HTN',
    intervention:
      'Reviewed concepts of the DASH diet and educated client on lowering sodium intake and choosing heart-healthy fats to improve blood pressure.',
  },
  {
    description: 'Accountability',
    intervention:
      'Meeting with an RD will help the client with accountability and mindfulness with nutrition choices, and help to brainstorm new meal and snack ideas from concepts already uses at home.',
  },
  {
    description: 'Intervention: Stress managament',
    intervention:
      'Educated client on importance of stress management and imact on GI and metabolic function. Discussed strategies for stress management.',
    height: 85,
  },
  {
    description: 'Variety',
    intervention:
      'Educated and encouraged client to try new foods, or different foods from similar food groups. Educated client on eating variety of colors and nutrient profiles "Eat the Rainbow".',
  },
  {
    description: 'Flavor enhancement for satisfaction',
    intervention:
      'Discussed with client the benefits of viewing food as more than just nutrients or fuel and adding in toppings/flavors/textures to increase satisfaction.',
    height: 70,
  },
  {
    description: 'Coping skills',
    intervention:
      'Reviewed healthy "coping skills" (ways of dealing with stress) of stressors that formerly triggered unhealthy eating behaviors.',
  },
  {
    description: '10 IE Principles',
    intervention:
      'RD reviewed 10 principles of Intuitive Eating by Evelyn Tribole, MS, RD and Elyse Resch, MS, RDN ; provides handout and takes turns with client reading out loud each principle.',
  },
  {
    description: 'Constipation',
    intervention:
      'Client will increase amount of fiber in diet by consuming a variety of whole grains, beans, and whole fruits and vegetables while also drinking ~8 cups of fluid/day to alleviate constipation.',
  },
  {
    description: 'Diarrhea',
    intervention:
      'Client will limit foods/beverages with high concentrations of sugar, caffeine, and spice, as well as have a small meal or snack every 3-4 hours.',
  },
  {
    description: 'Portions/meal structure',
    intervention:
      'Client will use hands and other models to eyeball portion sizes, as well as MyPlate/Plate Method to structure meals and obtain proper amounts of each food group.',
  },
  {
    description: 'Growth Charts',
    intervention:
      'Client will continue to follow/resume following their trend on the growth chart at the XXX percentile.',
    height: 55,
  },
  {
    description: 'Allergies',
    intervention:
      'Patient will strictly avoid XXX due to allergy and read food labels to avoid any XXX ingredients in products, and eat XXX to supplement any missing nutrients due to allergy.',
  },
  {
    description: 'MI',
    intervention:
      "Used Motivational Interviewing techniques to explore client's readiness to change; asked open-ended questions, listen in a supportive manner, provides affirmations, offers feedback, acknowledges struggle/pain, shows empathy, and helps to clarify and set goals.",
  },
  {
    description: 'Sleep',
    intervention:
      'Educated client on importance of sleep hygeine and adequate sleep for health/wellness, disease prevention/management, and weight concerns.',
  },
  {
    description: 'Dietary Supplements',
    intervention:
      'Discussed benefit of vitamin, mineral and/or other supplements to meet micronutrient needs to avoid and/or correct insufficiencies and/or deficiencies.',
    height: 70,
  },
  {
    description: 'Nutrient Insuffciency',
    intervention:
      'Reviewed dietary intake to assess overall vitamin/mineral intake and nutrients of concern. Nutrients of concern are: Potassium; Fiber; Calcium; and Vitamin D.',
  },
  {
    description: 'Nutrtion Professional referral',
    intervention:
      'Referral by nutrition professional to another nutrition professional with different expertise.',
  },
  {
    description: 'Nutrtion Prescription',
    intervention:
      'Provided client with tailored recommendations based on current reference standards and evidence based nutrition practice guidelines and related to the client’s health condition, nutrition diagnosis, and/or client values.',
  },
  {
    description: 'Feeding Environment',
    intervention:
      'Adjustment of the factors where food is served (feeding environment) that impact food consumption such as lighting, odors, distraction etc.',
  },
  {
    description: 'Texture Modified diet',
    intervention:
      'Modify composition of meals/snacks with texture modified foods diet.',
  },
  {
    description: 'Dietary Modification',
    intervention:
      'Modify composition of meal/snacks for specific foods or ingredients.',
  },
  {
    description: 'Nutrition Counseling',
    intervention: 'Provided nutrition counseling based on health belief model.',
  },
  {
    description: 'Self Monitoring',
    intervention:
      'Nutrition counseling based on self monitoring strategies client can use for.',
  },
  {
    description: 'Anti-inflammatory diet',
    intervention:
      'Provided list of foods that will help decreased inflammation. Discussed the benefits of reducing inflammation and educated client of foods that typically increase inflammation.',
  },
  {
    description: 'Assigned reading',
    intervention:
      'Client will read an assigned reading to help with transitioning away from a negative eating attitude to a positive one. Readings include topics on Intuitive Eating, the Eating Competence Model, Health at Every Size, and weight stigma.',
  },
  {
    description: 'Balanced meals/snacks',
    intervention:
      'Educated client on what makes a meal/snack well balanced and importance of having well balanced meals/snacks i.e. proper fuel for body, longer lasting energy, satiety, and post eating blood sugar control.',
    height: 85,
  },
  {
    description: 'Benefits of reducing sugar intake',
    intervention:
      'Discussed the benefits of decreasing sugar. Explained the "rollercoaster" effect that a high sugar diet creates. Brainstormed with client acceptable substitutes. Encouraged mindful eating and paying attention to events that trigger sugar cravings.',
  },
  {
    description: 'Body Image Values',
    intervention:
      'Helped client with determining 5-7 core values and exploring how well these values are being met as a way to move from away from external validation for body.',
  },
  {
    description: 'Common Goals',
    intervention: `1. Increase fiber in diet- Aim to incorporate more fruits, vegetables, whole grains, nuts and seeds; and aim for 25 grams per day of fiber. See handouts sent via email

    2. Increasing hydration- Educated client on importance of hydration and hydration needs. Client will gradually increase water/fluids to goal of 108 oz /day
    
    3. Exercise- Discussed how exercise can be beneficial for both mental and physical health. Suggested a wide variety of different activities combining both cardio/strength. Suggested using Apple Smart watch to keep track of steps; aim to gradually increase steps to a goal of 10,000 steps per day
    
    4. Self monitoring-Introduced Healthie. Client will keep daily food journals in Healthie electronic food journal; upload pictures, note hunger/fullness, and document feelings/triggers associated with eating.
    
    5. Accountability- Meeting with an RD will help the client with accountability and mindfulness with nutrition choices, and help to brainstorm new meal and snack ideas from concepts already uses at home.`,
    height: 355,
  },
  {
    description: 'RD check in',
    intervention:
      'Client and RD will continue to check in on X as we meet and determine further interventions as needed. See email from XX visit for more information and resources.',
  },
  {
    description: 'Breakfast',
    intervention:
      'Instructed client on having breakfast within one hour of waking to provide energy, regulate blood sugar and appetite the rest of the day, and provide adequate opportunities for nutrition.',
  },
  {
    description: 'Body Image Work',
    intervention: `Instructed client on practicing activities to improve body image resilience including:

    • tolerating negative emotions
    • performing self-soothing activities
    • practicing mindfulness techniques
    • mirror work
    • challenging thoughts and beliefs`,
    height: 100,
  },
  {
    description: 'Intervnetion: Gluten Free Diet',
    intervention: `Educated client on foods to avoid while following a gluten free diet.
    Discussed the benefits of removing gluten from diet.
    Provided handouts of typical foods to avoid that contain gluten.`,
  },
  {
    description: 'General Health Promotion',
    intervention:
      'Educated client on general health promotion/disease prevention nutrition: increase fiber intake via fruits, vegetables, beans, whole grains; increase unsaturated fat intake via nuts/seeds, avocados, olive oil, fish; drink at least 64 oz fluid per day; decrease alcohol intake.',
  },
  {
    description: 'Fiber for health',
    intervention:
      'Discussed adequate fiber intake and benefits for blood sugar, cholesterol and gut health.',
  },
  {
    description: 'Exercise for overall health',
    intervention:
      'Discussed how exercise can be beneficial for both mental and physical health. Suggested a wide variety of different activities.',
  },
  {
    description: 'Electrolytes POTS',
    intervention:
      'Educated the client on the benefits of getting adequate electrolytes, especially sodium to help manage s/s of POTs.',
  },
  {
    description: 'Heart Burn',
    intervention:
      'Discussed with client several ways to manage heartburn: eliminating trigger foods, using OTC medication, and managing stress.',
  },
  {
    description: 'Making mealtimes work',
    intervention: `Reviewed ways to make mealtimes consistant.
    Ideas covered:
    • Planning for meals
    • Shopping for meals
    • Wash dishes in a timely manner - right after meals
    • Clean table off, create a pleasant eating environment`,
    height: 85,
  },
  {
    description: 'Mental Health',
    intervention: `"RD provided resources to help client: 
    • build community
    • find a meditation practice
    • create a list of relaxing activities
    • self soothe in times of distress"`,
    height: 70,
  },
  {
    description: 'Nutrtion Myths',
    intervention:
      'Provided client on information and resources to correct nutrition misinformation.',
  },
  {
    description: 'Permission to Eat',
    intervention:
      'Educated on the need to give unconditional permission to eat as much as is wanted as part of the eating disorder recovery process. Client will take a deep breath and give permission to eat as much as he/she wants before as many meals as possible, working up to doing this half the time or more.',
  },
  {
    description: 'Master List for Meal Planning',
    intervention: `Reviewed various meal planning strategies with patient. Suggested creating a master list of meal options to help streamline weekly meal planning. 
    Reviewed meal planning cheat sheet.
    Taught patient about balanced meals including protein, vegetables, carbohydrates and fat. Reviewed which foods fall into each category.
    Discussed portion size basics.`,
    height: 135,
  },
  {
    description: 'Probiotics',
    intervention:
      'Discussed benefits of using probiotics. Recommended particular probiotics and educated client on how to choose "third party tested" supplement brands.',
    height: 85,
  },
  {
    description: 'Protein/Carb intake for balance',
    intervention: `Protein Intake
    - Aim for at least 25g of protein with meals (minimum)
    - Try to get closer to 30-35g of protein (4-5 oz of meat) with meals for a total of 100g a day of protein
    - Okay to consume more than 100g of protein a day
    - Body best uses 25-55g of protein to support muscle 
    - Include protein every time you eat
    Carb Intake
    - Balance carbs with protein
    - Ex) 30g of protein (or more) with meals and 30g of carbs (or less) with meals
    - Avoid eating carbs by themselves, always pair with protein
    - If eating carbs, focus on complex carbs - beans, fruit, whole grains`,
    height: 195,
  },
  {
    description: 'Weight Progress',
    intervention:
      'Discussed important considerations with weight and other ways to measure progress.',
  },
  {
    description: 'Weight Training',
    intervention:
      'Discussed benefits of weight training. Encouraged 2-3 days/week frequency. Reviewed types of weight training.',
  },
  {
    description: 'MVI supplement',
    intervention:
      'Discussed benefit of multivitamin with minerals in filling any nutritional gaps to promote overall health and wellness.',
  },
];
